// extracted by mini-css-extract-plugin
module.exports = {"appointmentHeldTabs":"AppointmentHeld_appointmentHeldTabs__36kvo","appointmentHeldDetailsContainer":"AppointmentHeld_appointmentHeldDetailsContainer__2LW-Y"};